module.exports = __webpack_public_path__ + "img/PlaySplitCardDrawPoker_DG.d23d6151.png";